module.exports = {"510321100":"旭阳镇","510321102":"双石镇","510321103":"望佳镇","510321107":"鼎新镇","510321110":"乐德镇","510321111":"过水镇","510321112":"古文镇","510321113":"河口镇","510321114":"新桥镇","510321115":"正紫镇","510321116":"度佳镇","510321117":"东佳镇","510321118":"长山镇","510321119":"保华镇","510321120":"留佳镇","510321121":"来牟镇","510321122":"双古镇","510321123":"观山镇","510321124":"高山镇","510321125":"东兴镇","510321126":"铁厂镇","510321202":"金花乡","510321203":"雷音乡","510321204":"古佳乡","510321205":"于佳乡","510321206":"复兴乡","510321207":"墨林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510321.json
// module id = 2099
// module chunks = 0